import { put, takeLatest, take, select } from 'redux-saga/effects';
import { types as snoozeTypes, setSnoozeTimer } from '../../actions/backendSnooze';
import { isCallStarted, getIsTrainerActive, getSessionDurationMsec } from '../../selectors/call';
import { DEFAULT_SNOOZE_TIMER } from '../../../utils/snooze';
import { types as callTypes } from '../../actions/backendCall';
import { types as commonTypes } from '../../actions/backendCommon';
import { proto } from '../../../proto/AsrProto';
import { wsConnectionClosingCodes } from '../../../constants/backend';

const putThunk = (action: unknown) => put(action as never);

interface SagaAction {
    type?: string;
    payload?: {
        snoozeFor?: number;
    };
}

export function* onSnoozeTrainer(action: SagaAction): Generator<unknown, void, unknown> {
    try {
        const { snoozeFor = DEFAULT_SNOOZE_TIMER } = action.payload || {};

        const isTrainerActive = yield select(getIsTrainerActive);

        // Send snooze request
        yield putThunk(setSnoozeTimer(snoozeFor));

        // Cover the case when trainer is already inactive
        // and user adds snooze timer again
        if (isTrainerActive) {
            const isStarted = yield select(isCallStarted);

            // Wait success request to end the call or close all connections
            yield take(snoozeTypes.SET_SNOOZE_TIMER_SUCCESS);

            if (isStarted) {
                // Trigger Post Recording
                const sessionOffsetMsec = Number((yield select(getSessionDurationMsec)) || 0);
                yield put({
                    type: callTypes.CALL_ENDED,
                    payload: {
                        reason: proto.FinalizationReason.CALL_END_NORMAL,
                        sessionEndOffsetMsec: sessionOffsetMsec,
                        eventMeta: {
                            source: 'snooze'
                        }
                    }
                });
            }

            // Use same saga if trainer already snoozed
            // Code NO_RELOAD WS closing code
            yield put({
                type: commonTypes.CLOSE_ALL_CONNECTIONS,
                payload: {
                    reason: proto.FinalizationReason.CALL_END_NORMAL,
                    code: wsConnectionClosingCodes.NO_RELOAD
                }
            });
        }
    } catch {
        yield put({ type: snoozeTypes.SNOOZE_TRAINER_FAIL });
    }
}

export function* handleSnoozeTrainer(): Generator<unknown, void, unknown> {
    yield takeLatest(snoozeTypes.SNOOZE_TRAINER, onSnoozeTrainer);
}

export default [handleSnoozeTrainer()];
